import React, { Component } from "react";
import { Paper, Typography, Select, MenuItem } from "@material-ui/core";
import _ from "lodash";
export default class JobPackAssigneesArrayList extends Component {
    constructor(props) {
        super(props);
        this.state = { profile: props.profile, edit: props.edit };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.profile !== this.props.profile) {
            this.setState({ profile: this.props.profile });
        }
    }
    renderDropdown = (label, key, opts, multiselect = false) => {
        const { profile } = this.state;
        if (this.state.edit) {
            return (
                <div
                    style={{
                        display: "flex",
                        marginBottom: 30,
                        marginLeft: 50,
                    }}
                >
                    <Typography style={{ width: 200 }} variant="h6">
                        <b>{label}:</b>
                    </Typography>
                    <Select
                        style={{ marginLeft: 40, width: "50%" }}
                        value={
                            multiselect && profile[key] !== undefined
                                ? profile[key].map((e) => {
                                      return _.get(e, "uid") || null;
                                  })
                                : multiselect && profile[key] === undefined
                                ? []
                                : profile[key]
                        }
                        multiple={multiselect}
                        onChange={(event) => {
                            if (multiselect) {
                                let newArray = _.flattenDeep(
                                    _.compact(
                                        event.target.value.map((e) => {
                                            return _.compact(
                                                opts.map((f) => {
                                                    if (e === f.uid) {
                                                        return f;
                                                    } else return false;
                                                })
                                            );
                                        })
                                    )
                                );
                                this.props.callback(key, newArray);
                            } else this.props.callback(key, event.target.value);
                        }}
                    >
                        {opts.map((e) => {
                            return (
                                <MenuItem
                                    key={e.uid}
                                    value={multiselect ? e.uid : e.user_name}
                                >
                                    {e.user_name}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        display: "flex",
                        marginBottom: 30,
                        marginLeft: 50,
                    }}
                >
                    <Typography style={{ width: 200 }} variant="h6">
                        <b>{label}:</b>
                    </Typography>
                    <Typography style={{ marginLeft: 40 }} variant="subtitle2">
                        {Array.isArray(this.state.profile[key])
                            ? this.state.profile[key].map((e) => {
                                  return `${e.user_name} , `;
                              })
                            : this.state.profile[key]}
                    </Typography>
                </div>
            );
        }
    };
    render() {
        const { users } = this.props;
        return (
            <Paper
                style={{
                    padding: 20,
                    textAlign: "center",
                }}
            >
                <Typography style={{ marginBottom: 30 }} variant="h6">
                    Assignees
                </Typography>
                {this.renderDropdown(
                    "Assigned Supervisor",
                    "assigned_supervisor",
                    users,
                    false
                )}
                {this.renderDropdown(
                    "Assigned Manager",
                    "assigned_manager",
                    users,
                    false
                )}
                {this.renderDropdown(
                    "Assigned Operatives",
                    "assigned_operatives",
                    users,
                    true
                )}
            </Paper>
        );
    }
}
